import { createAsyncThunk } from '@reduxjs/toolkit';

import { AdminApiPaths } from '../../../api/APIPaths';
import APIDataProvider, {
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api/ApiDataProvider';
import { ICourseStudentForAdmin } from '.';

export type TGetCourseStudentsAsAdmin = {
  course: string;
  limit: number;
  offset: number;
};

export type TCreateCourseStudent = {
  course: string;
  student: string;
  startDate?: string;
  endDate?: string;
};

export type TUpdateCourseStudent = {
  id: string;
  status?: string;
  startDate?: string;
  endDate?: string;
};

const apiDataProvider = new APIDataProvider();

export const getCourseStudentsAsAdmin = createAsyncThunk(
  '/admin/course-students/list',
  async (data: TGetCourseStudentsAsAdmin) => {
    const { course, limit, offset } = data;

    const path = `${AdminApiPaths.courseStudents}?course=${course}&limit=${limit}&offset=${offset}`;

    const response = await apiDataProvider.get<
      TApiResponse<TApiPaginationResponse<ICourseStudentForAdmin>>
    >(path);

    return response.data;
  }
);

export const createCourseStudent = createAsyncThunk(
  '/admin/course-students/create',
  async (data: TCreateCourseStudent) => {
    const path = `${AdminApiPaths.courseStudents}`;

    const response = await apiDataProvider.post<
      TApiResponse<ICourseStudentForAdmin>
    >(path, data);

    return response.data;
  }
);

export const deleteCourseStudent = createAsyncThunk(
  '/admin/course-students/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.courseStudents}/${id}`;

    const response = await apiDataProvider.delete<
      TApiResponse<ICourseStudentForAdmin>
    >(path);

    return response.data;
  }
);

export const updateCourseStudent = createAsyncThunk(
  '/admin/course-students/update',
  async ({ id, ...data }: TUpdateCourseStudent) => {
    const path = `${AdminApiPaths.courseStudents}/${id}`;

    const response = await apiDataProvider.put<
      TApiResponse<ICourseStudentForAdmin>
    >(path, data);

    return response.data;
  }
);
